import React from 'react';

const PricingTable = ({ incallRates, outcallRates, extendedRates }) => {
  return (
    <div style={{ 
      padding: '24px 28px',
      background: 'rgba(90, 30, 43, 0.05)',
      borderLeft: '3px solid var(--burgundy)',
      marginBottom: '24px'
    }}>
      <h3 className="heading-3" style={{ marginBottom: '16px' }}>Pricing</h3>
      
      {/* Incall Rates */}
      {incallRates && (
        <div style={{ marginBottom: '20px' }}>
          <h4 className="body-regular" style={{ fontWeight: '600', marginBottom: '12px', color: 'var(--text-primary)' }}>Incall</h4>
          <div style={{ display: 'grid', gap: '12px' }}>
            {incallRates.map((rate, index) => (
              <div key={index} style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                <span className="body-small">{rate.duration}</span>
                <span className="body-small" style={{ fontWeight: '600', color: 'var(--burgundy)' }}>{rate.price}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Outcall Rates */}
      {outcallRates && (
        <div style={{ marginBottom: '20px', paddingTop: '16px', borderTop: '1px solid var(--border-light)' }}>
          <h4 className="body-regular" style={{ fontWeight: '600', marginBottom: '12px', color: 'var(--text-primary)' }}>Outcall</h4>
          <div style={{ display: 'grid', gap: '12px' }}>
            {outcallRates.map((rate, index) => (
              <div key={index} style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                <span className="body-small">{rate.duration}</span>
                <span className="body-small" style={{ fontWeight: '600', color: 'var(--burgundy)' }}>{rate.price}</span>
              </div>
            ))}
          </div>
        </div>
      )}
        
      {/* Extended Time */}
      {extendedRates && (
        <div style={{ paddingTop: '16px', borderTop: '1px solid var(--border-light)' }}>
          <h4 className="body-regular" style={{ fontWeight: '600', marginBottom: '12px', color: 'var(--text-primary)' }}>Extended Time</h4>
          <div style={{ display: 'grid', gap: '12px' }}>
            {extendedRates.map((rate, index) => (
              <div key={index} style={{ marginBottom: '8px' }}>
                <p className="body-small" style={{ marginBottom: '4px' }}>{rate.duration}</p>
                <p className="body-small" style={{ fontWeight: '600', color: 'var(--burgundy)' }}>{rate.price}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PricingTable;
